import React from "react";
import { NavLink } from "react-router-dom";
import Header8 from "./../Common/Header8";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import BlogSidebar from "./../Elements/BlogSidebar";

var bnrimg = require("../../images/banner/banner.jpg")

var bgimg1 = require("./../../images/background/cross-line2.png");

class PostRightSidebar extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("./assets/js/custom.js");
  }
  render() {
    return (
      <>
        <Header8 />
        <div className="page-content ">
          <Banner
            title="COMMUNIQUE Projet Vallée Val d’OR II"
            pagename="COMMUNIQUE Projet Vallée Val d’OR II"
            bgimage={bnrimg}
            parent="Actualités"
            parentLink="/annonces"
          />
          {/* SECTION CONTENT START */}
          <div className="section-full p-tb80 inner-page-padding">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-md-12 col-sm-12">
                  <div className="blog-single-space max-w900 ml-auto mr-auto">
                    {/* BLOG START */}
                    <div className="blog-post blog-detail text-black">
                      <div className="sx-post-media">
                        <div className="portfolio-item">
                          <img
                            className="img-responsive w-100"
                            src={require("./../../images/blog/event_2.jpg")}
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="sx-post-meta  m-t20">
                        <ul>
                          <li className="post-date">
                            <strong>31 </strong> <span>Decembre 2020</span>{" "}
                          </li>
                        </ul>
                      </div>
                      <div className="sx-post-title ">
                        <h3 className="post-title">
                          COMMUNIQUE Projet Vallée Val d’OR II
                        </h3>
                      </div>
                      <div className="sx-post-text">
                        <p>
                          Dans le cadre du renforcement de ses actions de
                          communication, le bureau de l’Association la vallée a
                          le plaisir d’informer ses adhérents et membres
                          bénéficiaires du programme « Vallée Val d’Or II » qu’à
                          l’issue des visites de l’appartement témoin, des
                          réunions d’information seront programmées selon un
                          calendrier arrêté, avec les membres du bureau de
                          l’Association et ce, à partir de la 3ème semaine de
                          janvier 2021.
                        </p>
                        <p>
                          A ce titre et compte tenu du contexte lié au Corona
                          virus et des difficultés rencontrées pour la tenue des
                          AG, les réunions seront tenues, par groupe selon le
                          planning arrêté avec, un nombre limité des
                          participants, en respectant les mesures de
                          distanciation et les gestes barrières (port
                          obligatoire de la bavette, gel,…).
                        </p>
                        <p>
                          Chaque membre bénéficiaire, sera destinataire d’une
                          invitation précisant la date, l’heure et le lieu de la
                          réunion, par les moyens digitaux à disposition (Mail,
                          SMS ou Whatsapp).
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* SIDE BAR START */}
                <div className="col-lg-4 col-md-12 col-sm-12 sticky_column">
                  <BlogSidebar />
                </div>
                {/* SIDE BAR END */}
              </div>
            </div>
          </div>
          {/* SECTION CONTENT END */}
        </div>

        <Footer />
      </>
    );
  }
}

export default PostRightSidebar;
